import React from 'react'
import Header from '../inc/Header'
import ScrollToTop from "react-scroll-to-top";
import {Link} from "react-router-dom";
import misaa2026worled from "../images/misaa _worlded.jpg";
import World_Environment_DaY from "../images/WED.jpeg";
import World_Environment_Day from "../images/World_Environment_Day.jpeg";
import World_Environment_Dayphoto from "../images/World_Environment_Day photo.jpeg";
import World_Environment_Dayphotosirspeech from "../images/World_Environment_Day sir speech.jpeg";
import World_Environment_Day_misaa from "../images/World.jpeg";
import World_Environment_Day_misaa2026 from "../images/World_Environment_Day misaa.jpeg";
import poribeshbandhusamman2026 from "../images/Paribesh bandhu Samman 2026.jpg";

function Worlded2026() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
         
                    <ScrollToTop smooth top="100" color="grey"/>
        
                    <div className='bestberhamporeschoolmis'>
                    <div className="album py-1">
                        <div className="container mt-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/Gallery" style={{ color: "darkblue" }} >Back</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page"> M.I.S.A.A Honoured on World Environment Day</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                     </div>

                     <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={poribeshbandhusamman2026} className="card-img-top" alt="poribeshbandhusamman2026" />

                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={World_Environment_DaY} className="card-img-top" alt="misaa2026" />

                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={World_Environment_Day} className="card-img-top" alt="jackets were distributed" />

                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={World_Environment_Dayphoto} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>

                        <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={World_Environment_Dayphotosirspeech} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>
                         <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={World_Environment_Day_misaa} className="card-img-top" alt="jackets were distributed 2026" />

                            </div>
                        </div>
                         <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={World_Environment_Day_misaa2026} className="card-img-top" alt="World_Environment_Day_misaa2026" />

                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card">
                                <img src={misaa2026worled} className="card-img-top" alt="World_Environment_Day_misaa2026" />

                            </div>
                        </div>
                      </div>
                      </div>
                      </div>
                   

<br/>
    </div>
  )
}

export default Worlded2026